import { render, staticRenderFns } from "./MenuFormulario.vue?vue&type=template&id=6360acbd&"
import script from "./MenuFormulario.vue?vue&type=script&lang=ts&"
export * from "./MenuFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports